<template>
  <div id="Subjecttable">
    <el-table
      :data="tableData"
      @row-dblclick="rowdblclick"
      @row-click="rowclick"
      @header-dragend="headerdragend"
      border
      :fit="asdaaf"
      style="width: 100%;"
      :height="heights==true?tableHeight:'300'"
      class="tabone_sty"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height:'37px',padding:'0'}"
    >
      <!-- backgroundColor:#ff6; -->
      <el-table-column width="80" height="500" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i :class="isInners" @click="clickIcon" style="color:#2594ff;font-size:18px"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column width="80" align="center" label="类型">
        <template slot-scope="scope">
          <i
            :class="scope.row.IsDir?'el-icon-folder':'el-icon-tickets'"
            style="color:#e9cb70;font-size:18px"
          ></i>
        </template>
      </el-table-column>
      <template v-for="(obj,index) in ObtainHeader">
        <el-table-column
          :width="obj.Width==''?'':obj.Width"
          align="center"
          :index="index"
          :key="index"
          :prop="obj.Key"
          :label="obj.Rename"
          v-if="obj.Show"
        ></el-table-column>
      </template>

      <el-table-column
        v-if="columnS"
        align="center"
        fixed="left"
        label="操作"
        width="150"
        class="asdadfas"
      >
        <template slot-scope="scope">
          <el-button
            @click="handleClick(scope.row)"
            :disabled="scope.row.Modify!=1?false:true"
            type="text"
            size="small"
          >修改</el-button>
          <!--  -->
          <el-button
            deleteClick
            @click="deleteClick(scope.row,scope.$index,tableData)"
            :disabled="scope.row.Must!=1?false:true"
            type="text"
            size="small"
          >删除</el-button>

          <el-button id="btn" deleteClick type="text" size="small">
            <el-dropdown trigger="click" class="clearfix">
              <el-button type="text" size="small">更多</el-button>
              <el-dropdown-menu slot="dropdown" @click="asdfgh(scope.row)">
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="small"
                    @click="Discontinuation(scope.row,scope.$index)"
                    :disabled="scope.row.CStop!==1?false:true"
                  >{{scope.row.StopedName=='停用'?'启用':'停用'}}</el-button>
                </el-dropdown-item>
                <el-dropdown-item class="clearfix">
                  <el-button
                    type="text"
                    size="small"
                    @click="classification(scope.row,scope.$index)"
                    :disabled="scope.row.Classify!=1?false:true"
                  >分类</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPages"
      :page-sizes="[10, 20,50,100]"
      :page-size="pageSizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
  </div>
</template>

<script>
import tool from "@/utils/tool.js";
export default {
  name: "Subjecttable",
  data() {
    return {
      tableHeight: window.innerHeight - 300 + "px",
      heightss: this.heights,
      isInner: this.isInners,
      asdaaf: true,
      data: this.tableData,
      icons: false,
      icon: false,
      column: this.columnS,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pageSizes, //每页显示数量
      // tableData: [],
      img: this.imgs,
      // filetext: require("../../assets/images/icon_set.png"),
      filetext: "",
      file: "",
      Discontext: true,
      Discontexts: "",
      Discon: [],
      taData: [],
      taData1: this.ObtainHeader
    };
  },
  props: {
    tableData: Array,
    ObtainHeader: Array,
    currentPages: Number,
    totals: Number,
    pageSizes: Number,
    imgs: String,
    heights: {
      type: Boolean
    },
    columnS: {
      type: Boolean,
      default: true
    },
    isInners: {
      type: String,
      default: "el-icon-s-tools"
    }
  },
  methods: {
    headerdragend(newWidth, oldWidth, column, event) {
      let Baseno = false;
      this.ObtainHeader.map(item => {
        if (item.Key == column.property) {
          Baseno = item.BaseNo;
          return;
        }
      });
      if (Baseno != false) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.$attrs.pargam.Model,
          data: [
            {
              BaseNo: Baseno,
              Width: newWidth
            }
          ]
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams)
          })
          .then(res => {
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    asdfgh() {
      // console.log(12356);
    },
    clickIcon() {
      this.$emit("clickIcon");
    },
    handleSizeChange(val) {
      // 赋值
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      // 赋值
      this.$emit("handleCurrentChange", val);
    },

    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 双击一行
    rowdblclick(obj) {
      this.$emit("dblclick", obj);
    },
    // 单击某一行
    rowclick(obj) {
      this.$emit("rowclick", obj);
    },
    handleClick(obj) {
      this.$emit("handleClick", obj);
    },

    deleteClick(data, index, obj) {
      // console.log(obj);

      this.$emit("deleteClick", data, index, obj);
    },
    Discontinuation(data, index) {
      this.$emit("Discontinuation", data, index);
    },
    classification(data, index) {
      this.$emit("classification", data, index);
    }
  }
};
</script>

<style lang="less">
.el-table__fixed-header-wrapper {
  z-index: 25;
}

// .is-center {
//   padding: 6px 0 !important;
// }
.btn {
  border: none;
  background-color: transparent;
  color: #409eff;
  font-size: 12px;
  margin-right: 15px;
  padding: 7px 0;
}
.clearfix {
  .el-button {
    padding: 0 !important;
  }
}
.tabone_sty {
  .input_sty {
    background: inherit;
    border: 0;
    outline: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
    padding: 0 10px;
    color: #606266;
  }
}
.el-table__fixed-right {
  width: 130px;
  height: 100% !important;
  right: 0px !important;
}
// .el-button--small{
//   padding: 0 !important;
// }
.el-button {
  font-size: 12px !important;
}
// .is-center {
//   padding: 6px 0 !important;
// }
.el-table .cell {
  // overflow: hidden !important;
  white-space: nowrap !important;
}
// .tabone_sty td {
//   padding: 0 0 !important;
// }
// .tabone_sty th {
//   padding: 0 !important;
// }
.item {
  margin-top: 10px;
  margin-right: 40px;
}
.el-table__header-wrapper {
  width: 101% !important;
}
.el-pagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/tables/table.vue